import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/General/Faq/faq.default"
    ).then((module) => ({
        default: module.FaqDefault
    }))
);
